import React from 'react'

import { Box, Icon, NumberBadge, Text } from '@factorialco/deprecated-design-system'
import { Tooltip } from '@factorialco/f0-react/dist/experimental'
import {
  UniversalExportsExporterExtraOption,
  UniversalExportsExporterField,
  UniversalExportsExporterFilter,
  UniversalExportsExporterGroupColumn,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import ExportFormat from './ExportFormat'
import ExtraOptions from './ExtraOptions'
import Fields from './Fields'
import Filters from './Filters'
import GroupableColumn from './GroupableColumn'

interface SectionTitleProps {
  title: string
  step: number
  fieldsTitleTooltip?: string
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title, step, fieldsTitleTooltip }) => (
  <Box flexDirection="row" gap="s8">
    <NumberBadge label={step} />
    <Text.Normal weight="medium" size="300" color="textPrimary">
      {title}
    </Text.Normal>
    {fieldsTitleTooltip && (
      <Tooltip label={fieldsTitleTooltip}>
        <span>
          <Icon.Medium icon="info-circle-line" color="grey700" />
        </span>
      </Tooltip>
    )}
  </Box>
)

interface Props {
  fieldsTitleTooltip?: string
  fields: UniversalExportsExporterField[]
  filters: UniversalExportsExporterFilter[]
  extraOptions: UniversalExportsExporterExtraOption[]
  groupableColumns: UniversalExportsExporterGroupColumn[]
  overrideFilters?: Record<string, Array<number | string | boolean>>
  onFilterChange?: () => void
}

export const Content: React.FC<Props> = ({
  fieldsTitleTooltip,
  fields,
  filters,
  extraOptions,
  groupableColumns,
  overrideFilters = {},
  onFilterChange,
}) => {
  return (
    <Box gap="s48" flexGrow>
      <Box gap="s16">
        <SectionTitle title={i18n.t('universal_exports.export_format.title_v2')} step={1} />
        <Box gap="s16" paddingLeft="s32">
          <ExportFormat />
          {extraOptions.length > 0 && <ExtraOptions exporterOptions={extraOptions} />}
          {groupableColumns.length > 0 && <GroupableColumn groupableColumns={groupableColumns} />}
        </Box>
      </Box>
      {filters.length > 0 && (
        <Box gap="s16">
          <SectionTitle title={i18n.t('universal_exports.filter.title_v2')} step={2} />
          <Box paddingLeft="s32">
            <Filters
              exporterOptions={filters}
              overrideFilters={overrideFilters}
              onFilterChange={onFilterChange}
            />
          </Box>
        </Box>
      )}
      <Box flexDirection="column" gap="s16">
        <SectionTitle
          title={i18n.t('universal_exports.config.title_v2')}
          step={filters.length > 0 ? 3 : 2}
          fieldsTitleTooltip={fieldsTitleTooltip}
        />
        <Fields exporterOptions={fields} />
      </Box>
    </Box>
  )
}
